import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {TreeSelect} from "primereact/treeselect";
import axios from "axios";
import {Dialog} from "primereact/dialog";
import {InputNumber} from "primereact/inputnumber";
import ReceiptFileGetService from "../../../2.0/_services/receipt/ReceiptFileGetService";
import ReceiptPdfViewerComponent from '../../../2.1/finance/receipt/ReceiptPdfViewerComponent';
import ReceiptShowComponent from "../../../2.1/finance/receipt/ReceiptShowComponent";

const CostallocationApproveListComponent = (props) => {

  const {t} = props;
  const [costallocationapproves, setCostallocationapproves] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [costTypes, setCostTypes] = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [filters, setFilters] = useState({
    'cost_type': { value: null, matchMode: 'equals' },
    'cost_center': { value: null, matchMode: 'equals' },
    'amountMin': { value: null, matchMode: 'gte' },
    'amountMax': { value: null, matchMode: 'lte' },
  });
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: filters
  });
  const [selectedCostallocations, setSelectedCostallocations] = useState([]);

  const [receiptPreviewVisible, setReceiptPreviewVisible] = useState(false);
  const [receiptPreviewLoading, setReceiptPreviewLoading] = useState(false);
  const [receiptPreviewId, setReceiptPreviewId] = useState(null);
  const [receiptPreviewFile, setReceiptPreviewFile] = useState(null);
  const openReceiptPreview = (receiptId) => {
    setReceiptPreviewId(receiptId);
    setReceiptPreviewVisible(true);
    setReceiptPreviewLoading(true);
    setReceiptPreviewFile(null);
    ReceiptFileGetService(receiptId)
      .then(response => {
        if (response.data && response.data.file) {
          setReceiptPreviewFile(response.data.file);
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setReceiptPreviewLoading(false);
      });
  };

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      const approvalFilter = (query && query.includes('?') ? '&' : '?') + 'search[approved_by][operator]==&search[approved_by][value]=null';
      const min = lazyParams.filters?.amountMin?.value;
      const max = lazyParams.filters?.amountMax?.value;
      let amountFilter = '';
      if (min !== null && max !== null) {
        amountFilter = `&search[amount][operator]=between&search[amount][value]=${min},${max}`;
      } else if (min !== null) {
        amountFilter = `&search[amount][operator]=>=&search[amount][value]=${min}`;
      } else if (max !== null) {
        amountFilter = `&search[amount][operator]=<=&search[amount][value]=${max}`;
      }
      apiCall('get', '/api/v2/cost-allocation' + query + approvalFilter + amountFilter)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setCostallocationapproves(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_cost_allocation_approve') &&
          <Button type="button" icon="pi pi-check" tooltip={t('approve')}
                  className="p-button-warning  p-ml-2 p-mt-2 p-mt-xl-0" tooltipOptions={{position: 'left'}}
                  onClick={() => {
                      setLoading(true);
                      apiCall('put', '/api/v2/cost-allocation/batch/approve', [rowData.id])
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres jóváhagyás!');
                          window.App.setState({rerenderCostallocationApproveList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                  }}/>
        }
      </React.Fragment>
    );
  }

  const ratioBodyTemplate = (rowData) => {
    const total = Number(rowData?.cost_item?.amount ?? 0);
    const part = Number(rowData?.amount ?? 0);
    if (!total || total === 0) return '0%';
    return Math.round((part / total) * 100).toString() + '%';
  }

  const nameBodyTemplate = (rowData) => {
    if(rowData?.cost_item?.source === 'RECEIPT_LINE') {
      return (
        <Button className="p-button-link p-0" label={rowData?.cost_item?.name} onClick={() => {
          if(rowData?.receipt?.id) {
            openReceiptPreview(rowData.receipt.id);
          }
        }}/>
      )
    }
    return (
      <>{rowData?.cost_item?.name}</>
    )
  }

  const costTypeFilterElement = (options) => (
    <Dropdown
      value={options.value}
      options={costTypes}
      optionLabel="name"
      optionValue="id"
      showClear
      placeholder={t('selectPlaceholder')}
      onChange={(e) => options.filterApplyCallback(e.value)}
      appendTo={document.body}
    />
  );

  const costCenterFilterElement = (options) => (
    <TreeSelect
      value={options.value ? String(options.value) : null}
      options={costCenters}
      filter
      showClear
      placeholder={t('selectPlaceholder')}
      onChange={(e) => options.filterApplyCallback(e.value ? Number(e.value) : null)}
      appendTo={document.body}
    />
  );

  const amountRangeFilterElement = () => {
    const min = lazyParams?.filters?.amountMin?.value ?? null;
    const max = lazyParams?.filters?.amountMax?.value ?? null;
    return (
      <div className="p-d-flex p-ai-center" style={{ gap: '5px', minWidth: '220px' }}>
        <InputNumber
          value={min}
          placeholder={t('minPlaceholder')}
          mode="decimal"
          useGrouping={false}
          inputStyle={{ width: '80px' }}
          onValueChange={(e) => {
            const next = {
              ...lazyParams.filters,
              amountMin: { ...lazyParams.filters.amountMin, value: e.value ?? null },
            };
            setLazyParams({ ...lazyParams, first: 0, page: 0, filters: next });
          }}
        />
        <span style={{ margin: '0 2px' }}>&harr;</span>
        <InputNumber
          value={max}
          placeholder={t('maxPlaceholder')}
          mode="decimal"
          useGrouping={false}
          inputStyle={{ width: '80px' }}
          onValueChange={(e) => {
            const next = {
              ...lazyParams.filters,
              amountMax: { ...lazyParams.filters.amountMax, value: e.value ?? null },
            };
            setLazyParams({ ...lazyParams, first: 0, page: 0, filters: next });
          }}
        />
      </div>
    );
  };

  useEffect(() => {
    apiCall('get', '/api/v2/cost-type?item_per_page=9999')
      .then(response => setCostTypes(response.data.data.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
    apiCall('get', '/api/v2/cost-center/tree')
      .then(response => setCostCenters(response.data.data.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderCostallocationApproveList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={costallocationapproves} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
                 selection={selectedCostallocations}
                 onSelectionChange={(e) => setSelectedCostallocations(e.value)}
                 selectionMode="checkbox"
      >
        <Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>
        <Column field="cost_item.name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter body={nameBodyTemplate}></Column>
        <Column field="cost_type.name" header={t('columnCostType')} sortable filter filterField="cost_type" filterElement={costTypeFilterElement}></Column>
        <Column field="cost_center.name" header={t('columnCostCenter')} sortable filter filterField="cost_center" filterElement={costCenterFilterElement}></Column>
        <Column field="cost_item.source" header={t('columnCostSource')} body={(rowData) => {
          const source = rowData?.cost_item?.source;
          return source ? t(`costSource${source}`) : '';
        }}></Column>
        <Column field="amount" header={t('columnAmount')} sortable className={"p-text-right"} filter filterElement={amountRangeFilterElement}  body={(rowData) => {
          const num = Number(rowData?.amount);
          if (rowData?.amount === null || rowData?.amount === undefined || Number.isNaN(num)) {
            return '';
          }
          const currency = rowData?.currency || rowData?.cost_item?.currency || 'HUF';
          return window.App.currencyFormatter(currency, num);
        }}></Column>
        <Column header={t('columnCostRatio')} className={"p-text-right"} body={ratioBodyTemplate}></Column>




        {/* <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column> */}
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
      {selectedCostallocations && selectedCostallocations.length > 0 &&
        <div className="p-mt-3 p-text-right">
          <Button label={t('approveSelected')} icon="pi pi-check"
                  className="p-button-success"
                  loading={loading}
                  onClick={() => {
                    setLoading(true);
                    apiCall('put', '/api/v2/cost-allocation/batch/approve', selectedCostallocations.map(item => item.id))
                      .then(() => {
                        window.App.toastShow('success', 'Kijelölt tételek jóváhagyva!');
                        setSelectedCostallocations([]);
                        window.App.setState({rerenderCostallocationApproveList: Math.random()})
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                      .finally(() => {
                        setLoading(false);
                      })
                  }}
          />
        </div>
      }
      <Dialog visible={receiptPreviewVisible}
        header={t('receiptView')}
        modal
        dismissableMask
        maximizable
        style={{width: '92vw'}}
        contentStyle={{height: '85vh'}}
        onHide={() => {
          setReceiptPreviewVisible(false);
          setReceiptPreviewId(null);
          setReceiptPreviewFile(null);
        }}>
          {receiptPreviewLoading ? (
            <span className={"p-d-block p-py-4"} style={{fontSize: '1.2em'}}>
              <i className="pi pi-spin pi-spinner" style={{fontSize: '0.9em'}}></i>
              &nbsp;Betöltés...
            </span>
          ) : (
            <>
              {receiptPreviewFile ? (
                <ReceiptPdfViewerComponent file={receiptPreviewFile} height={800} />
              ) : (
                receiptPreviewId ? (
                  <div style={{height: '80vh', overflow: 'auto'}}>
                    <ReceiptShowComponent initialValues={{id: Number(receiptPreviewId)}} />
                  </div>
                ) : (
                  <small>Nincs megjeleníthető fájl.</small>
                )
              )}
            </>
          )}
        </Dialog>
    </>
  )
}
export default withTranslation('common')(CostallocationApproveListComponent);
